import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ProductionOrderLineStatusReferenceService extends BaseReferenceService {
  constructor() {
    super('ProductionOrderLineStatusReference');
  }
}
